import React from "react";
import { Calendar, Tag, ArrowRight, Facebook, Twitter, Linkedin } from "lucide-react";
import PageHero from "../components/PageHero";
import useReveal from "../hooks/useReveal";
import usePageMeta from "../hooks/usePageMeta";
import { POSTS } from "../data/site";

const formatDate = (s) =>
  new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function News() {
  useReveal();
  usePageMeta({ title: "News & Updates", description: "Community news, wellbeing tips and organisation updates from Thrive Bridge." });

  return (
    <>
      <PageHero
        eyebrow="News & updates"
        title="Stories, tips and updates from the community."
        lead="Read about the work we're doing together, and find practical ideas for your own wellbeing."
      />

      <section className="container-page section-spacing">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {POSTS.map((p) => (
            <article
              key={p.slug}
              data-testid={`post-card-${p.slug}`}
              className="fade-up bg-white border border-[var(--tb-border)] rounded-3xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden border-b border-[var(--tb-border)]">
                <img src={p.image} alt="" className="h-full w-full object-cover" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs text-[var(--tb-muted)] mb-3">
                  <span className="inline-flex items-center gap-1"><Tag className="h-3 w-3" /> {p.category}</span>
                  <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> {formatDate(p.date)}</span>
                </div>
                <h2 className="font-serif-display text-xl text-[var(--tb-text)] mb-2 text-balance">{p.title}</h2>
                <p className="text-[var(--tb-text-2)] flex-1 text-pretty">{p.excerpt}</p>
                <div className="mt-5 flex items-center justify-between">
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 text-[var(--tb-primary)] font-semibold hover:gap-3 transition-all"
                  >
                    Read more <ArrowRight className="h-4 w-4" />
                  </button>
                  <div className="flex items-center gap-1">
                    {[Facebook, Twitter, Linkedin].map((Icon, i) => (
                      <button
                        key={i}
                        aria-label={`Share on social network ${i + 1}`}
                        className="h-8 w-8 grid place-items-center rounded-full border border-[var(--tb-border)] text-[var(--tb-text-2)] hover:text-[var(--tb-primary)] hover:border-[var(--tb-primary)] transition-colors"
                      >
                        <Icon className="h-3.5 w-3.5" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
